<template>
  <v-layout column>
    <v-flex>
      <HeaderBar>
        <v-icon slot="icon">account_circle</v-icon>
          My Profile
      </HeaderBar>
    </v-flex>
    <v-flex v-if="gettingProfile">
      <v-progress-linear indeterminate></v-progress-linear>
    </v-flex>
    <v-flex v-else>
      <v-layout row>
        <v-flex mr-2>
          <v-text-field
            disabled
            label="First Name"
            :value="user.first_name"
          >
          </v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            disabled
            label="Last Name"
            :value="user.last_name"
          >
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex>
          <v-text-field
            disabled
            label="Email"
            :value="user.email"
          >
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-divider class="mt-4"></v-divider>
      <v-layout column class="mt-4">
        <v-flex xs2>
          <PasswordResetDialog :toSelf="true" :email="user.email" />
        </v-flex>
        <v-flex xs12>
          <v-checkbox
            label="Receive message emails"
            :input-value="receiveEmail"
            @change="value => updateReceiveEmail(value)"
            persistent-hint
            :hint="`Get all new messages as emails to ${ user.email }`"
          >
          </v-checkbox>
        </v-flex>
        <v-flex xs12 class="mt-3">
          <div class="subheading">Default calendar view</div>
          <v-radio-group v-model="defaultCalendarView" row>
            <v-radio label="List" value="list"></v-radio>
            <v-radio label="Month" value="month"></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import PasswordResetDialog from '@/components/hr/password-reset-dialog.vue'

export default {
  components: {
    PasswordResetDialog
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    exampleComputed: function () {
      return this.example
    },
    defaultCalendarView: {
      get () {
        return this.user.defaultCalendarView || 'list'
      },
      set (value) {
        this.$store.dispatch('userAuth/setDefaultCalendarView', value)
      },
    },
  },
  created () {
    this.setUp()
  },
  watch: {
  },
  data: function () {
    return {
      receiveEmail: false,
      gettingProfile: false,
    }
  },
  methods: {
    updateReceiveEmail (value) {
      this.$store.dispatch("profiles/update", {
        receive_email: value
      })
      .then(profile => {
        this.receiveEmail = profile.receiveEmail
        let message
        if (value) {
          message = "You will get messages as emails"
        } else {
          message = "You'll no longer get messages as emails"
        }
        this.$store.dispatch("global/showSnackbarSuccess", { message: message })
      })
      .catch(e => {
        this.$store.dispatch("global/showSnackbarError", { message: "Something went wrong" })
      })
      .finally(r => {
      })
    },
    setUp () {
      this.getUserProfile()
    },
    getUserProfile () {
      this.gettingProfile = true
      this.$store.dispatch("profiles/get")
      .then(profile => {
        this.receiveEmail = profile.receiveEmail
      })
      .finally(r => {
        this.gettingProfile = false
      })
    },
  },
}
</script>

<style scoped>
</style>
